export default __webpack_public_path__ + "static/media/volunteers.41b40da3.jpg";